/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetDriftDetail {
    getFixupPrototypeFunction() { return BudgetDriftDetail.fixupPrototype; }

    static newInstance(model: Partial<BudgetDriftDetail>): BudgetDriftDetail {
        let obj = Object.assign(new BudgetDriftDetail(), model);
        BudgetDriftDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetDriftDetail>): BudgetDriftDetail {
        if (!model) return null;
        return BudgetDriftDetail.newInstance(<BudgetDriftDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetDriftDetail) {
        if (!obj) return;

        models.BudgetDriftDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetDriftDetail): boolean {
        Object.setPrototypeOf(obj, BudgetDriftDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.budget_drift === undefined) {
            this.budget_drift = 0;
        }
        if (this.cost_spend === undefined) {
            this.cost_spend = 0;
        }
        if (this.budget_amount === undefined) {
            this.budget_amount = 0;
        }
    }

    /**
     * Actual or Forecast Budget_Drift
     */
    budget_drift: number;

    /**
     * Cost Spend for the clouds
     */
    cost_spend: number;

    /**
     * Budget Amount.
     */
    budget_amount: number;

    /**
     * Name of budget
     */
    budget_name: string;

}
